import React, { useContext, useEffect, useState } from 'react';
import { Container, Nav, Navbar } from 'react-bootstrap';
import { AuthContextClient } from '../context/AuthContextClient';
import { firestore } from '../Firebase';
import { Link } from 'react-router-dom';

const HeaderClient = () => {
  const { logoutClient } = useContext(AuthContextClient) || {};
  const [pageTitle, setPageTitle] = useState('Back End');

  useEffect(() => {
    const unsubscribe = firestore
      .collection('settings')
      .doc('customization')
      .onSnapshot(
        (doc) => {
          if (doc.exists && doc.data().pageTitle) {
            setPageTitle(doc.data().pageTitle);
          }
        },
        (error) => {
          console.error('Error fetching customization:', error);
        }
      );
    return () => unsubscribe();
  }, []);

  return (
    <Navbar expand="sm" className="bg-body-tertiary pop3d">
      <Container fluid>
        <Navbar.Brand>{pageTitle}</Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="me-auto">
            <Nav.Link as={Link} to="/questions">
              Questions
            </Nav.Link>
            <Nav.Link as={Link} to="/participants">
              Participants
            </Nav.Link>
          </Nav>
          <Nav className="ms-auto">
            <button className="btn btn-primary" onClick={logoutClient}>
              Logout
            </button>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default HeaderClient;
